module.exports = __webpack_public_path__ + "img/telegram-svgrepo-com.521c7ca3.svg";